import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

export interface ToastInput {
	type: 'success' | 'error' | 'info' | 'warning';
	delay?: number;
	message?: string;
	error?: HttpErrorResponse;
	autoHide?: boolean;
}

export interface Toast {
	type: 'success' | 'error' | 'info' | 'warning';
	delay?: number;
	message?: string;
	error?: HttpErrorResponse;
	autoHide: boolean;
}

@Injectable({
	providedIn: 'root'
})
export class ToastService {
	toasts: Toast[] = [];

	show(toast: ToastInput) {
		this.toasts.push({
			autoHide: true,
			...toast
		});
	}

	remove(toast: Toast) {
		this.toasts = this.toasts.filter((t) => t !== toast);
	}

	clear() {
		this.toasts.splice(0, this.toasts.length);
	}
}
